module.exports = __webpack_public_path__ + "img/HOT.3fe30226.svg";